import reportHeaderStyles from './reportHeader.module.scss';

export const ReportHeader = ({ title }) => {
    return <span className={reportHeaderStyles['title']}>{title}</span>;
};
